module.exports = __webpack_public_path__ + "static/media/MentalHealth.3cc47470.jpg";